import { render, staticRenderFns } from "./goodsOrderDetail.vue?vue&type=template&id=6f4c0c16&scoped=true&"
import script from "./goodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./goodsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsOrderDetail.vue?vue&type=style&index=0&id=6f4c0c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c0c16",
  null
  
)

export default component.exports